(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('backbone-metal-classify'), require('backbone.radio'), require('underscore'), require('es6-promise')) :
  typeof define === 'function' && define.amd ? define(['backbone-metal-classify', 'backbone.radio', 'underscore', 'es6-promise'], factory) :
  global.Backbone.Service = factory(global.classify, global.Radio, global._, global.PromisePolyfill)
}(this, function (classify, Radio, _, PromisePolyfill) { 'use strict';

  const resolved = PromisePolyfill.Promise.resolve();

  Radio.Channel = classify(Radio.Channel);

  /**
   * @class Service
   */
  var backbone_service = Radio.Channel.extend({
    /**
     * @constructs Service
     */
    constructor() {
      let start = _.once(() => resolved.then(() => this.start()));
      let requests = _.result(this, 'requests');
      _.each(requests, (val, key) => {
        this.reply(key, (...args) => {
          let promise = start().then(() => this[val](...args));

          promise.catch(err => {
            this.onError(err);
          });

          return promise;
        });
      });

      this._super(...arguments);
    },

    /**
     * @abstract
     * @method setup
     */
    setup() {},

    /**
     * @abstract
     * @method start
     */
    start() {},

    /**
     * @abstract
     * @method onError
     */
    onError() {}
  });

  return backbone_service;

}));
